import { isSuperAdmin } from "@/src/utils/utils";

import {
  emergencyLevels,
  examCategoriesIds,
  Reference,
  referenceCategories,
  ReferenceCategory,
} from "@/src/data/allTypes";

import { Input } from "@/src/components/universalInput";
import { USER } from "@/src/data/globalVariables";
import { useState } from "react";
import { SnomedConceptPicker } from "../../snomed/SnomedConceptPicker";
import { FrequentReferencesList } from "../structures/frequentReferencesList";
import ReorderableSections from "./reorderableSections";
import { ReferenceAssociatedDocuments } from "./referenceAssociatedDocuments";

export function ReferenceForm({
  current,
  categories,
  onChange,
}: {
  current: Reference;
  categories: ReferenceCategory[];
  onChange: (newValue: Reference) => void;
}) {
  let [reference, setReference] = useState(current || ({} as Reference));
  function setNewValue(newValue: Reference) {
    setReference({ ...newValue });
    onChange({ ...newValue });
  }

  const isExam = examCategoriesIds.includes(
    (reference?.category as ReferenceCategory) || ""
  );

  let childrenCategories: ReferenceCategory[] = [];
  if (isExam) childrenCategories = ["examStep"];

  console.log("current reference", reference);
  return (
    <div className="grid c1 gap10">
      <Input
        name={"Nom"}
        type={"text"}
        shouldFocus={true}
        value={reference.name}
        onChange={(newValue) => {
          setNewValue({ ...reference, name: newValue });
        }}
      />
      <Input
        name={"Id (optionnel)"}
        type={"text"}
        placeholder="Ex: references:test3"
        value={reference.id}
        onChange={(newValue) => {
          setNewValue({ ...reference, id: newValue });
        }}
      />
      {/* <Input
        name={"Description (optionnel)"}
        type={"text"}
        value={reference.description}
        onChange={(newValue) => {
          setNewValue({ ...reference, description: newValue });
        }}
      /> */}
      {reference.category == "motive" && (
        <Input
          name={"Niveau d'urgence"}
          type={"chips"}
          value={reference.emergencyLevel}
          options={Object.values(emergencyLevels)}
          onChange={(newValue) => {
            setNewValue({ ...reference, emergencyLevel: newValue });
          }}
        />
      )}

      {isSuperAdmin(USER.get()) && (
        <SnomedConceptPicker
          value={reference.snomedConcept}
          onChange={(newValue) => {
            setNewValue({ ...reference, snomedConcept: newValue });
          }}
        ></SnomedConceptPicker>
      )}

      {/* <Input
        name={"Code CIM10 (optionnel)"}
        type={"text"}
        value={reference.cim10Code}
        onChange={(newValue) => {
          setNewValue({ ...reference, cim10Code: newValue });
        }}
      />
      <Input
        name={"Code CIM11 (optionnel)"}
        type={"text"}
        value={reference.cim11Code}
        onChange={(newValue) => {
          setNewValue({ ...reference, cim11Code: newValue });
        }}
      />

      <Input
        name={"Visible ?"}
        type={"chips"}
        value={reference.isVisible?.toString()}
        options={[
          { value: "true", label: "Oui" },
          { value: "false", label: "Non" },
        ]}
        onChange={(newValue) => {
          setNewValue({ ...reference, isVisible: newValue == "true" });
        }}
      /> */}

      {(categories?.length || 0) > 1 && (
        <Input
          name={"category"}
          type={"select"}
          value={reference.category}
          options={categories?.map((categoryId) => {
            let category = referenceCategories[categoryId];
            return { value: category?.id, label: category?.name };
          })}
          onChange={(newValue) => {
            setNewValue({ ...reference, category: newValue });
          }}
        />
      )}

      {/* 
      <Input
        name={"Nombre d'utilisations (optionnel)"}
        type={"text"}
        value={reference.usageCount}
        onChange={(newValue) => {
          setNewValue({ ...reference, usageCount: newValue });
        }}
      /> */}

      {/* {childrenCategories.length > 0 && (
        <ReorderableReferenceChildren
          label={isExam ? "Etapes" : "Sous-éléments"}
          current={reference.children || []}
          categories={childrenCategories}
          onChange={(newValue) => {
            setNewValue({ ...reference, children: newValue });
          }}
        />
      )} */}

      <ReorderableSections
        label="Sections"
        scoreIntervals={null}
        onScoreIntervalsChange={null}
        current={reference.sections || []}
        onChange={(newSections) => {
          setNewValue({ ...reference, sections: newSections });
        }}
      ></ReorderableSections>

      <FrequentReferencesList
        title={"Children"}
        currentReferences={reference.children || []}
        onChange={(newValue) => {
          setNewValue({ ...reference, children: newValue });
        }}
      ></FrequentReferencesList>

      <ReferenceAssociatedDocuments reference={reference} />
    </div>
  );
}
